import qs from "query-string"
import amplitude from "amplitude-js"
import smoothscroll from "smoothscroll-polyfill"
import { setLoading } from "../interview/actions"
import { captureException } from "./error"
import { AMPLITUDE_TOKEN } from "./constants"

const emailRe = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const amp_instance = amplitude.getInstance()
if (amp_instance && AMPLITUDE_TOKEN) {
  amp_instance.init(AMPLITUDE_TOKEN)
}

export const suggestionText = (optionText, search) => {
  optionText = optionText.toLowerCase()
  search = search.toLowerCase().trim()
  let search_words = search.split(" ")
  let text = optionText
  let optionWords = text.split(", ")
  if (optionWords.length > 1) {
    let lastItem = optionWords[optionWords.length - 1].toLowerCase()
    let i = 1
    while (
      search.indexOf(lastItem.slice(0, i)) !== -1 &&
      i <= lastItem.length
    ) {
      i++
    }
    text = search
    if (lastItem.indexOf(search_words[search_words.length - 1]) === -1) {
      text += " "
    }
    text += i <= lastItem.length ? lastItem.slice(i - 1) : ""
  }
  let index = text.search(escapeRegEx(search))
  let before = index === -1 ? text : text.substring(0, index)
  let during = index === -1 ? "" : text.substring(index, index + search.length)
  let after =
    index === -1 ? "" : text.substring(index + search.length, text.length)
  return { before: before, during: during, after: after }
}

export const filterQuestions = (chatItems, active) => {
  let questions = []
  let items = chatItems
    .slice(0, active + 1)
    .filter(item => item.type !== "response")

  let i = items.length - 1
  let currentItem = items[i]
  while (currentItem && !currentItem.filter) {
    currentItem = items[--i]
  }
  while (currentItem && currentItem.filter) {
    questions.push(currentItem)
    currentItem = items[--i]
  }
  questions.reverse()
  return questions
}

export const trackEvent = (event, props = {}, sensitive = true) => {
  // sensitive has to be explicitly set to false for the props parameters
  // to be sent to a third party tracking service like Amplitude. Make sure you're
  // not sending personal information but only generic. If you're not sure, check
  // with legal so we are not violating HIPAA.

  let gaProps = {}

  Object.keys(props).forEach(key => {
    gaProps[event + ": " + key] = props[key]
  })

  if (window.features) {
    Object.keys(window.features).forEach(key => {
      gaProps[event + ": " + key] = window.features[key]["variant"]
    })
  }

  if (window.dataLayer) {
    if (!sensitive) window.dataLayer.push({ event: event, ...gaProps })
    else window.dataLayer.push({ event: event })
  }

  if (AMPLITUDE_TOKEN) {
    if (!sensitive) amplitude.getInstance().logEvent(event, props)
    else amplitude.getInstance().logEvent(event)
  }
}

Array.prototype.contains = function(item) {
  return this.indexOf(item) > -1
}

Array.prototype.remove = function(item) {
  let index = this.indexOf(item)
  if (index > -1) {
    this.splice(index, 1)
  }
}

Array.prototype.findFirst = function(f) {
  for (var i = 0; i < this.length; i++) {
    if (f(this[i])) {
      return this[i]
    }
  }
}

Array.prototype.findIndex = function(f) {
  for (var i = 0; i < this.length; i++) {
    if (f(this[i])) {
      return i
    }
  }
  return -1
}

String.prototype.toProperCase = function() {
  return this.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
      value: function(search, rawPos) {
          var pos = rawPos > 0 ? rawPos|0 : 0;
          return this.substring(pos, pos + search.length) === search;
      }
  });
}

export const durationToHours = duration => {
  if (!duration) {
    return
  }
  let multipliers = {
    minutes: 1 / 60,
    hours: 1,
    days: 24,
    weeks: 168,
    months: 720,
    years: 8760,
  }
  let hours = parseInt(duration.amount) * multipliers[duration.unit]
  if (hours > 1051200) {
    // 120 years
    hours = 1051200
  }

  return hours
}

export const isEditing = (items, index) => {
  // If a question has a question image, it will have another bubble after it
  // that isn't the active. Therefore, the actual bubble should be the second
  // to last image on the list.
  let onLastImageQues =
    !items.slice(index + 1, items.length).filter(item => item.type !== "image")
      .length > 0

  return index < items.length - 1 && !onLastImageQues
}

// Helper method to find what index item would be if items were only the ones
// of item's type. E.g. for a search item, will tell you if it is the first, second, etc.
export const indexOfType = (items, item) => {
  let index = -1
  items
    .filter(x => x.type === item.type)
    .forEach((x, i) => {
      if (x.index === item.index) {
        index = i
      }
    })
  return index
}

export const handleLoading = (dispatch, doNothing, func, context) => {
  if (doNothing) return

  dispatch(setLoading(true, context))
  return func()
    .then(() => dispatch(setLoading(false)))
    .catch(captureException)
}

export const groupBy = function(xs, key) {
  return xs.reduce(function(rv, x) {
    ;(rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

export const SubDomain = (function() {
  if (window.location.href.indexOf("buoyhealth.com") === -1) {
    return undefined
  }

  var subdomain = /:\/\/([^./]+)/.exec(window.location.href)
  if (subdomain) {
    subdomain = subdomain[1]
    // We don't really need to include this anymore, but we'll avoid a lot of
    // unnecessary calls to the backend resulting in 404s if we keep these sanity
    // checks for known subdomain lookalikes that aren't supported brands.
    if (
      !subdomain ||
      subdomain === "www" ||
      subdomain.startsWith("research") ||
      subdomain.startsWith("sandbox") ||
      subdomain.startsWith("staging")
    ) {
      return undefined
    }
  }
  return subdomain
})()

export const QueryStringBrand = (function() {
  return qs.parse(window.location.search).brand
})()

export const escapeRegEx = function(s) {
  return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")
}

export const calcAge = age => {
  let yearsOld
  if (age.exact) {
    yearsOld = age.exact
  } else {
    switch (age.unit) {
      case "months":
        yearsOld = age.value / 12
        break
      case "days":
        yearsOld = age.value / 365
        break
      default:
        yearsOld = age.value
    }
  }
  if (yearsOld > 89) {
    return 89
  } else {
    return yearsOld
  }
}

export const validateEmail = email => emailRe.test(email)

// Have to use !! to cast to boolean because && is doing a short circuit assignment
export const validatePassword = pass =>
  !!(pass.length >= 8 && pass.match(/[a-z]/i) && pass.match(/[0-9]/i))

export const freeTextOpen = item => {
  if (!item || !item.options) return false
  for (let i = 0; i < item.options.length; i++) {
    let option = item.options[i]
    if (
      option.isfreetext &&
      item.response &&
      item.response.filter(x => x.token === option.token).length
    ) {
      return true
    }
  }
  return false
}

export const touchSupport = () =>
  "ontouchstart" in window ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0

export const addBeforeUnload = () => {
  window.onbeforeunload = event => {
    event.preventDefault()
    let message =
      "Are you sure you want to leave this page? All unsaved data will be lost."
    event.returnValue = message
    return message
  }
}

export const unmountBeforeUnload = () => {
  window.onbeforeunload = null
}

export const capitalizeString = str => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

// (https://stackoverflow.com/questions/326069/)
export const inIframe = () => {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

export const toCamel = s => {
  return s.replace(/([-_][a-z])/gi, $1 => {
    return $1
      .toUpperCase()
      .replace("-", "")
      .replace("_", "")
  })
}

export const formatRecommendationResponse = rec => {
  const fields = [
    "time",
    "insurance",
    "phone",
    "hours",
    "app",
    "cost",
    "available_to",
  ]
  let infoSection = {}
  // We generate the info section by iterating through each info field (on line 4)
  // and setting it to the contents of each object-key pair
  fields.forEach(field => {
    if (rec[field]) {
      infoSection[toCamel(field)] = rec[field]
      delete rec[field]
    }
  })
  rec.info = infoSection
  return rec
}

export const scroll = (pixels = null) => {
  // Scroll to bottom of chat after recording response.
  const container = document.getElementById("chatlist")
  // Appbox is used for the editor tool
  const appbox = document.getElementById("app_box")
  const scrollWindow = appbox || window

  if (container) {
    smoothscroll.polyfill()
    setTimeout(() => {
      const scrollposition = container.scrollHeight
      scrollWindow.scrollTo({ top: scrollposition, behavior: "smooth" })
    }, 100)
  }
}

export const scrollBy = pixels => {
  const container = document.getElementById("chatlist")
  // Appbox is used for the editor tool
  const appbox = document.getElementById("app_box")
  const scrollWindow = appbox || window

  if (container) {
    smoothscroll.polyfill()
    setTimeout(() => {
      let scrollposition
      if ("getBoundingClientRect" in container) {
        scrollposition = -container.getBoundingClientRect().top + pixels
      } else {
        scrollposition = container.offsetTop + pixels
      }
      scrollWindow.scrollTo({ top: scrollposition, behavior: "smooth" })
    }, 100)
  }
}

export const partsOfSpeech = (pov, sex, key) => {
  // TODO
  // Review naming of the keys
  const povDict = {
    male: {
      adjective: "his",
      beVerb: "he is",
      beVerbContraction: `he's`,
      haveVerb: "he has",
      haveVerbContraction: `he's`,
    },
    female: {
      adjective: "her",
      beVerb: "she is",
      beVerbContraction: `she's`,
      haveVerb: "she has",
      haveVerbContraction: `she's`,
    },
    neutral: {
      subject: "you",
      adjective: "your",
      beVerb: "you are",
      beVerbContraction: `you're`,
      haveVerb: "you have",
      haveVerbContraction: `you've`,
    },
  }
  if (pov === "self") return povDict.neutral[key]
  else if (pov !== "self" && sex === "male") return povDict.male[key]
  else if (pov !== "self" && sex === "female") return povDict.female[key]
}

export const isInAlarmAgent = context => {
  if (context.startsWith("triage_rule") || context === "complaint") {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./assets/common/common.js